import React from 'react';
import Card from 'react-toolbox/lib/card';
import CardBody from './CardBody';
import Logo from './Logo';
import Spinner from './Spinner';
import styles from '../components/pages/LoginPage.scss';

const LoginLoadingView = () => {
  return (
    <Card className={styles.loginFormCard}>
      <CardBody>
        <Logo />
        <Spinner />
      </CardBody>
    </Card>
  );
};

export default LoginLoadingView;



// WEBPACK FOOTER //
// ./src/client/src/components/LoginLoadingView.js